/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { datadogLogs, Logger } from "@datadog/browser-logs";

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    DD_LOGS?: Logger;
  }
}

datadogLogs.init({
  clientToken: String(process.env.REACT_APP_DD_RUM_CLIENT),
  service: "fleetcontrol",
  site: "datadoghq.com",
  version: String(process.env.REACT_APP_VERSION),
  env: String(process.env.REACT_APP_ENV),
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  telemetrySampleRate: 0,
  forwardConsoleLogs: ["warn", "error"],
});

export const logger = datadogLogs.logger;

export { datadogLogs } from "@datadog/browser-logs";
